<template>
  <div class="page-create-box">
    <div class="create-pane">
      <div class="create-pane__left">
        <vh-form
          :model="viewingProtocolForm"
          ref="viewingProtocolForm"
          :rules="viewingProtocolFormRules"
          label-width="88px"
          class="std-form"
        >
          <vh-form-item label="观看协议" prop="is_open">
            <div class="switch__box">
              <vh-switch
                v-model="viewingProtocolForm.is_open"
                :active-value="1"
                @change="protocolChange"
                :inactive-value="0"
                active-color="#FB3A32"
                inactive-color="#CECECE"
                :active-text="
                  viewingProtocolForm.is_open
                    ? '已开启，观看直播前展示观看协议'
                    : '开启后，观看直播前展示观看协议'
                "
              ></vh-switch>
            </div>
          </vh-form-item>
          <vh-form-item class="protocol-title" label="协议标题" prop="title">
            <vh-input
              :disabled="viewingProtocolForm.is_open === 0"
              v-model="viewingProtocolForm.title"
              v-clearEmoij
              :maxlength="50"
              autocomplete="off"
              placeholder="请输入《观看协议》标题"
              show-word-limit
            ></vh-input>
          </vh-form-item>
          <vh-form-item prop="content" :label="`协议内容`">
            <v-editor
              modelType="restriction"
              :placeholder="introPlaceholder"
              :class="viewingProtocolForm.is_open === 0 ? 'disabled-editor' : ''"
              class="editor-wrap"
              save-type="live"
              :isReturn="true"
              ref="unitImgTxtEditor"
              :disabled="viewingProtocolForm.is_open === 0"
              v-model="viewingProtocolForm.content"
            ></v-editor>
          </vh-form-item>
          <!--  -->
          <!-- <vh-form-item label="进入规则" prop="rule">
              <vh-radio-group v-model="viewingProtocolForm.rule"  :disabled="viewingProtocolForm.is_open === 0">
                <vh-radio :label="0">同意后进入直播间</vh-radio>
                <vh-radio :label="1">阅读后进入直播间</vh-radio>
              </vh-radio-group>
          </vh-form-item> -->
          <vh-form-item label="协议声明" prop="statement_status">
            <div class="switch__box">
              <vh-switch
                v-model="viewingProtocolForm.statement_status"
                :disabled="viewingProtocolForm.is_open === 0"
                :active-value="1"
                :inactive-value="0"
                active-color="#FB3A32"
                inactive-color="#CECECE"
                :active-text="
                  viewingProtocolForm.statement_status
                    ? '已开启，可以添加隐私协议外链'
                    : '开启后，可以添加隐私协议外链'
                "
              ></vh-switch>
            </div>
          </vh-form-item>
          <vh-form-item
            class="protocol-item"
            v-if="viewingProtocolForm.statement_status"
            prop="statement_content"
          >
            <vh-input
              :disabled="viewingProtocolForm.is_open === 0"
              @input="handleInputContent($event)"
              :maxlength="100"
              class="title-inform"
              show-word-limit
              v-model="viewingProtocolForm.statement_content"
              autocomplete="off"
              placeholder="我已阅读并同意"
            ></vh-input>
          </vh-form-item>
          <vh-form-item
            class="protocol-item item-title"
            v-if="viewingProtocolForm.statement_status"
            prop="proptocolTitle_0"
          >
            <vh-input
              :disabled="viewingProtocolForm.is_open === 0"
              @input="handleInput($event, 0, 'title')"
              :maxlength="100"
              v-model="viewingProtocolForm.proptocolTitle_0"
              show-word-limit
              autocomplete="off"
              placeholder="请输入第1行中包含的文字才能实现跳转效果"
            ></vh-input>
            <i
              class="vh-icon-circle-plus-outline optIcon"
              v-if="viewingProtocolForm.is_open === 1 && statementList && statementList.length == 1"
              @click="privacyAdd"
            ></i>
          </vh-form-item>

          <vh-form-item
            class="protocol-item item-link"
            v-if="viewingProtocolForm.statement_status"
            prop="proptocolLink_0"
          >
            <vh-input
              :disabled="viewingProtocolForm.is_open === 0"
              @input="handleInput($event, 0, 'link')"
              :maxlength="100"
              v-model="viewingProtocolForm.proptocolLink_0"
              class="title-inform"
              show-word-limit
              autocomplete="off"
              placeholder="请输入http://或https://开头的链接"
            ></vh-input>
          </vh-form-item>
          <vh-form-item
            class="protocol-item item-title"
            v-if="statementList.length > 1 && viewingProtocolForm.statement_status"
            prop="proptocolTitle_1"
          >
            <vh-input
              :disabled="viewingProtocolForm.is_open === 0"
              @input="handleInput($event, 1, 'title')"
              :maxlength="100"
              class="title-inform"
              v-model="viewingProtocolForm.proptocolTitle_1"
              show-word-limit
              autocomplete="off"
              placeholder="请输入第1行中包含的文字才能实现跳转效果"
            ></vh-input>
            <i
              class="vh-icon-remove-outline optIcon"
              @click="deleteOptions"
              v-if="viewingProtocolForm.is_open === 1 && statementList && statementList.length == 2"
            ></i>
          </vh-form-item>

          <vh-form-item
            class="protocol-item item-link"
            v-if="statementList.length > 1 && viewingProtocolForm.statement_status"
            prop="proptocolLink_1"
          >
            <vh-input
              :disabled="viewingProtocolForm.is_open === 0"
              @input="handleInput($event, 1, 'link')"
              :maxlength="100"
              class="title-inform"
              v-model="viewingProtocolForm.proptocolLink_1"
              show-word-limit
              autocomplete="off"
              placeholder="请输入http://或https://开头的链接"
            ></vh-input>
          </vh-form-item>
          <vh-form-item label="点击同意">
            <vh-radio-group
              v-model="viewingProtocolForm.agree_type"
              :disabled="viewingProtocolForm.is_open === 0"
            >
              <vh-radio :label="0">直接点击</vh-radio>
              <vh-radio :label="1">阅读完内容</vh-radio>
              <vh-radio :label="2">
                至少阅读
                <vh-form-item prop="agree_time" style="display: inline-block">
                  <vh-input
                    type="number"
                    v-model="viewingProtocolForm.agree_time"
                    :disabled="viewingProtocolForm.is_open === 0"
                    :max="300"
                    placeholder="1-300"
                    autocomplete="off"
                    class="agree-time-radio-input"
                  >
                    <template slot="suffix">秒</template>
                  </vh-input>
                </vh-form-item>
              </vh-radio>
            </vh-radio-group>
          </vh-form-item>
          <vh-form-item label="">
            <vh-button
              :disabled="viewingProtocolForm.is_open === 0"
              type="primary"
              round
              v-preventReClick
              @click.prevent.stop="protocolSave"
            >
              保存
            </vh-button>
          </vh-form-item>
        </vh-form>
        <div class="hide-white" v-show="!viewingProtocolForm.is_open"></div>
      </div>
      <div class="create-pane__right">
        <!-- 预览区域 -->
        <SimulatorPreview :onlyMobile="true">
          <section class="agree_preview" slot="mobile" v-if="viewingProtocolForm.is_open">
            <div class="preview_dialog">
              <h3 class="preview_title">
                {{ viewingProtocolForm.title }}
                <i class="vh-icon vh-icon-close"></i>
              </h3>
              <div class="preview_content">
                <div v-html="viewingProtocolForm.content"></div>
                <div
                  v-html="privacyFormatter"
                  v-if="viewingProtocolForm.statement_status == 1"
                ></div>
              </div>
              <div class="preview_footer">
                <vh-button
                  type="primary"
                  size="medium"
                  round
                  :disabled="viewingProtocolForm.agree_type == 1"
                >
                  同意并继续{{
                    viewingProtocolForm.agree_type == 2
                      ? `(${viewingProtocolForm.agree_time}s)`
                      : ''
                  }}
                </vh-button>
              </div>
            </div>
          </section>
        </SimulatorPreview>
      </div>
    </div>
  </div>
</template>

<script>
  import regRule from '@/utils/reg-rule';
  import SimulatorPreview from '@/components/SimulatorPreview';
  import VEditor from '@/components/Tinymce';
  import filterXSS from 'filterXSS';
  import { replaceWithRules } from '@/utils/utils.js';
  export default {
    name: 'viewingProtocol.vue',
    components: {
      SimulatorPreview,
      VEditor
    },
    data() {
      return {
        viewingProtocolForm: {
          title: '',
          statement_status: 0,
          logo_url: null,
          content: '',
          is_open: 0,
          statement_content: '我已同意并阅读《观看协议》',
          statement_info: null,
          proptocolTitle_0: '观看协议',
          proptocolLink_0: '',
          proptocolTitle_1: '',
          proptocolLink_1: '',
          type: this.$route.params.str ? 1 : 0,
          webinar_id: this.$route.params.str || undefined,
          module: 0,
          agree_type: 0,
          agree_time: 5
        },
        introPlaceholder: '',
        brandType: 1,
        domain_url: '',
        statementList: [
          {
            title: '观看协议',
            link: ''
          }
        ],
        viewingProtocolFormRules: {
          title: [{ required: true, message: `请填写协议标题`, trigger: 'blur' }],
          content: [{ required: true, message: `请输入协议内容`, trigger: 'blur' }],
          statement_content: [{ required: true, message: `请填写协议提示内容`, trigger: 'blur' }],
          proptocolTitle_0: [{ required: true, message: `请填写协议名称`, trigger: 'blur' }],
          proptocolLink_0: [
            { required: true, message: `请填写协议链接`, trigger: 'blur' },
            {
              pattern: /(http|https):\/\/[\w\-_]+(\.[\w\-_]+).*?/,
              message: '请输入以http://或https://开头的标志链接',
              trigger: 'blur'
            }
          ],
          proptocolTitle_1: [{ required: true, message: `请填写协议名称`, trigger: 'blur' }],
          proptocolLink_1: [
            { required: true, message: `请填写协议链接`, trigger: 'blur' },
            {
              pattern: /(http|https):\/\/[\w\-_]+(\.[\w\-_]+).*?/,
              message: '请输入以http://或https://开头的标志链接',
              trigger: 'blur'
            }
          ],
          agree_time: [
            {
              validator: (rule, value, callback) => {
                if (
                  this.viewingProtocolForm.agree_type == 2 &&
                  (!value || !regRule.num8.test(value) || value > 300)
                ) {
                  return callback(new Error('请输入1-300正整数'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        }
      };
    },
    computed: {
      privacyFormatter() {
        let text = this.viewingProtocolForm.statement_content;
        let rules = [
          {
            before: this.viewingProtocolForm.proptocolTitle_0,
            after: `<a class="protocolLinkStyle" href="${
              this.viewingProtocolForm.proptocolLink_0 || 'javascript:void(0);'
            }" target="_blank">${this.viewingProtocolForm.proptocolTitle_0}</a>`
          }
        ];
        if (this.viewingProtocolForm.proptocolTitle_1) {
          let secondRule = {
            before: this.viewingProtocolForm.proptocolTitle_1,
            after: `<a class="protocolLinkStyle" href="${
              this.viewingProtocolForm.proptocolLink_1 || 'javascript:void(0);'
            }" target="_blank">${this.viewingProtocolForm.proptocolTitle_1}</a>`
          };
          rules.push(secondRule);
        }
        return replaceWithRules(text, rules);
      }
    },
    watch: {
      'viewingProtocolForm.content'(newVal) {
        this.introPlaceholder = newVal ? '' : '请输入《观看协议》内容';
      }
    },
    mounted() {
      console.log(this.brandType, 'this.brandType');
      this.initComp();
    },
    methods: {
      protocolChange(value) {
        // console.log(value, 'value')
        if (value === 0) {
          this.viewingProtocolForm.statement_info = JSON.stringify(this.statementList);
          // console.log(this.viewingProtocolForm, 'viewingProtocolForm');
          const { module, type, is_open, webinar_id } = this.viewingProtocolForm;
          this.$fetch('closeAgreement', this.$params({ module, type, is_open, webinar_id }))
            .then(res => {
              this.$vhMessage({
                message: `保存基本设置成功`,
                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
              // 重新获取数据
              // this.getProtocol();
            })
            .catch(res => {
              console.log(res);
              this.$vhMessage({
                message: res.msg || `保存基本设置失败`,
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
            });
        }
      },
      handleInputContent(value) {
        let statementList = this.statementList;
        statementList.forEach((item, index) => {
          let titleName = `proptocolTitle_${index}`;
          if (item.title && value.indexOf(item.title) === -1) {
            this.statementList[index].title = '';
            this.viewingProtocolForm[titleName] = '';
          }
        });
        console.log(value, 'value');
        // this.$set(this.viewingProtocolForm, 'statement_content', value)
      },
      handleInput(value, index, type) {
        console.log(value, index);
        let statement_content = this.viewingProtocolForm.statement_content;
        let titleName = `proptocolTitle_${index}`;
        let linkName = `proptocolLink_${index}`;
        // let matchPrivacy1 = this.viewingProtocolForm.proptocolTitle_0 ? statement_content.match(this.viewingProtocolForm.proptocolTitle_0) : null;
        // let matchPrivacy2 = this.viewingProtocolForm.proptocolTitle_1 ? statement_content.match(this.viewingProtocolForm.proptocolTitle_1) : null;
        // this.indexFirst = statement_content.indexOf(this.viewingProtocolForm.proptocolTitle_0)
        // this.indexSecond = statement_content.indexOf(this.viewingProtocolForm.proptocolTitle_1)
        // if(matchPrivacy1 && matchPrivacy2 && this.indexFirst === this.indexSecond){
        //     this.$vhMessage({
        //       message: '两个观看协议标题不能占用协议声明相同位置的相同字段，请先补充协议声明',
        //       showClose: true,
        //       // duration: 0,
        //       type: 'error',
        //       customClass: 'zdy-info-box'
        //     });
        //     return
        // }
        if (type === 'title') {
          this.viewingProtocolForm[titleName] = value;
          if (value && statement_content.indexOf(value) === -1) {
            this.statementList[index].title = '';
            this.viewingProtocolForm[titleName] = '';
            // let oldValue = value.substring(0, value.length-1)
            // console.log(value.substring(0, value.length-1), 'value.substring(0, value.length-1)')
            // let viewingProtocolForm = this.viewingProtocolForm
            // this.viewingProtocolForm.statement_content = viewingProtocolForm.statement_content.replace(oldValue, '')
          } else {
            this.statementList[index].title = value;
            this.viewingProtocolForm[titleName] = value;
          }
        } else {
          this.viewingProtocolForm[linkName] = value;
          this.statementList[index].link = value;
          // console.log(this.viewingProtocolForm, linkName, 'linkName')
        }
        // console.log(this.viewingProtocolForm, 'this.viewingProtocolForm[`proptocolTitle_${index}`]')
      },
      deleteOptions() {
        this.statementList.pop();
        let viewingProtocolForm = this.viewingProtocolForm;
        let oldValue = viewingProtocolForm.proptocolTitle_1;
        // console.log(oldValue, 'value.substring(0, value.length-1)')
        this.viewingProtocolForm.statement_content = viewingProtocolForm.statement_content.replace(
          '《' + oldValue + '》',
          ''
        );
        this.viewingProtocolForm.statement_content = viewingProtocolForm.statement_content.replace(
          '及',
          ''
        );

        this.viewingProtocolForm.proptocolTitle_1 = '';
        this.viewingProtocolForm.proptocolLink_1 = '';
      },
      privacyAdd() {
        let statementObj = {
          title: '观看协议2',
          link: ''
        };
        if (this.viewingProtocolForm.proptocolTitle_0) {
          let contentLength = this.viewingProtocolForm.statement_content.length;

          if (contentLength + 8 <= 100) {
            this.statementList.push(statementObj);
            this.viewingProtocolForm.statement_content += '及《观看协议2》';
            // this.viewingProtocolForm.proptocolTitle_1 = '观看协议2'
            this.$set(this.viewingProtocolForm, 'proptocolTitle_1', '观看协议2');
            this.$set(this.viewingProtocolForm, 'proptocolLink_1', '');
          } else {
            this.$vhMessage({
              message: '添加隐私协议会超出预览字数，请删减后再添加',
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          }
        } else {
          this.$vhMessage({
            message: '请完善可点击文字',
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
        }
      },
      handleUploadSuccess(res, file) {
        console.log(res, file);
        if (res.data) {
          let domain_url = res.data.domain_url || '';
          let file_url = res.data.file_url || '';
          this.viewingProtocolForm.logo_url = file_url;
          this.domain_url = domain_url;
        }
        // 触发验证
        this.$refs.viewingProtocolForm.validateField('logo_url');
        try {
          this.$refs.brandSetPreviewComp.signSetVoInfo(this.viewingProtocolForm, this.domain_url);
        } catch (e) {
          console.log(e);
        }
      },
      beforeUploadHandler(file) {
        console.log(file);
        const typeList = ['png', 'jpeg', 'gif', 'bmp'];
        console.log(file.type.toLowerCase());
        let typeArr = file.type.toLowerCase().split('/');
        const isType = typeList.includes(typeArr[typeArr.length - 1]);
        const isLt2M = file.size / 1024 / 1024 < 4;
        if (!isType) {
          this.$vhMessage({
            message: `标志图片只能是 ${typeList.join('、')} 格式!`,
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return false;
        }
        if (!isLt2M) {
          this.$vhMessage({
            message: `标志图片大小不能超过 4MB!`,
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return false;
        }
        return isType && isLt2M;
      },
      uploadProcess(event, file, fileList) {
        console.log('uploadProcess', event, file, fileList);
      },
      uploadError(err, file, fileList) {
        console.log('uploadError', err, file, fileList);
        this.$vhMessage({
          message: `标志图片上传失败`,
          showClose: true,
          // duration: 0,
          type: 'error',
          customClass: 'zdy-info-box'
        });
      },
      // 获取观看协议记录
      getProtocol() {
        //  this.viewingProtocolForm.proptocolTitle_0 = 'statement_info[0].title';
        //  this.viewingProtocolForm.proptocolLink_0 =' statement_info[0].link'
        let params = {
          type: this.$route.params.str ? 1 : 0,
          module: 0,
          webinar_id: this.$route.params.str || undefined
        };
        this.$fetch('getAgreement', this.$params(params))
          .then(res => {
            console.log(res);
            if (res && res.code === 200) {
              // this.$refs['viewingProtocolForm'] ? this.$refs['viewingProtocolForm'].resetFields() : '';
              if (res.data && res.data.title) {
                // this.viewingProtocolForm = res.data;
                this.$set(this.viewingProtocolForm, 'content', res.data.content);
                this.$set(this.viewingProtocolForm, 'title', res.data.title);
                this.$set(this.viewingProtocolForm, 'statement_status', res.data.statement_status);
                this.$set(this.viewingProtocolForm, 'is_open', res.data.is_open);
                this.$set(this.viewingProtocolForm, 'agree_type', res.data.agree_type);
                this.$set(this.viewingProtocolForm, 'agree_time', res.data.agree_time);
                if (res.data.statement_status) {
                  // this.$set(this.viewingProtocolForm, 'statement_info', res.data.statement_info)
                  this.$set(
                    this.viewingProtocolForm,
                    'statement_content',
                    res.data.statement_content
                  );
                  let statement_info = res.data.statement_info;
                  if (statement_info && statement_info.length > 0) {
                    this.statementList = statement_info;

                    statement_info.forEach((item, index) => {
                      let titleName = `proptocolTitle_${index}`;
                      let linkName = `proptocolLink_${index}`;
                      this.$set(this.viewingProtocolForm, titleName, item.title);
                      this.$set(this.viewingProtocolForm, linkName, item.link);
                    });
                  }
                }

                // console.log(this.viewingProtocolForm, this.statementList, ' this.statementList')
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      initComp() {
        this.brandType = this.$parent.type;
        this.getProtocol(); // 获取活动标志内容
      },
      // 保存
      protocolSave() {
        // console.log(this.viewingProtocolForm, this.statementList, 'this.statementList')
        this.$refs.viewingProtocolForm.validate(valid => {
          if (valid) {
            if (
              this.statementList.length === 2 &&
              this.statementList[0].title === this.statementList[1].title
            ) {
              this.$vhMessage({
                message: `隐私协议名称不能重复`,
                showClose: true,
                // duration: 0,
                type: 'error',
                customClass: 'zdy-info-box'
              });
              return;
            }
            this.viewingProtocolForm.statement_info = JSON.stringify(this.statementList);

            // console.log(this.viewingProtocolForm, 'viewingProtocolForm');
            this.$fetch('saveAgreement', this.$params(this.viewingProtocolForm))
              .then(res => {
                console.log(res, 'res');

                this.$vhMessage({
                  message: `保存基本设置成功`,
                  showClose: true,
                  // duration: 0,
                  type: 'success',
                  customClass: 'zdy-info-box'
                });
                // 重新获取数据
                // this.getProtocol();
              })
              .catch(res => {
                console.log(res);
                if (res.code === 513554) {
                  this.$vhMessage({
                    message: res.msg || `协议名称不能重复`,
                    showClose: true,
                    // duration: 0,
                    type: 'error',
                    customClass: 'zdy-info-box'
                  });
                  return;
                }
                this.$vhMessage({
                  message: res.msg || `保存基本设置失败`,
                  showClose: true,
                  // duration: 0,
                  type: 'error',
                  customClass: 'zdy-info-box'
                });
              });
          }
        });
      }
    }
  };
</script>

<style lang="less" scoped>
  .agree_preview {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    .preview_dialog {
      width: 240px;
      border-radius: 12px;
      padding: 0 16px;
      background: #fff;
      position: relative;
      .preview_title {
        min-height: 40px;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        padding: 16px 10px 0;
        i {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.45);
          position: absolute;
          top: 13px;
          right: 13px;
        }
      }
      .preview_content {
        max-height: 270px;
        overflow: auto;
        font-size: 12px;
        line-height: 20px;
        box-sizing: border-box;
        color: rgba(38, 38, 38, 1);
      }
      .preview_footer {
        height: 56px;
        padding-top: 8px;
        .vh-button {
          width: 100%;
        }
      }
    }
  }
  .agree-time-radio-input {
    width: 80px !important;
  }
</style>
